import React, { useState } from "react";
import Signup from "../Signup"; // Import the Signup component

import Dashboard from "../dashboard";
import Header from "../header";
import Sample from "../sample";

const Home = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  return (
    <>
      <Header />

      <div
        style={{
          height: "100%",
          backgroundColor: "#f5f5f5",
        }}
      >
        {loggedIn ? <Dashboard /> : <Sample />}
        {/* <Signup /> */}
      </div>
    </>
  );
};

export default Home;
